<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path d="M3.94026 10L0.545978 1.27187C0.309738 0.664393 0.902081 0.0834574 1.48805 0.289952L1.58039 0.329211L19.5804 9.32921C20.0986 9.58833 20.131 10.2979 19.6776 10.6133L19.5804 10.6709L1.58039 19.6709C0.997411 19.9623 0.364108 19.4264 0.515441 18.8238L0.545978 18.7282L3.94026 10L0.545978 1.27187L3.94026 10ZM2.64875 2.54044L5.25774 9.24944L11.8853 9.25003C12.265 9.25003 12.5788 9.53219 12.6285 9.89826L12.6353 10C12.6353 10.3797 12.3532 10.6935 11.9871 10.7432L11.8853 10.75L5.25774 10.7494L2.64875 17.4596L17.5679 10L2.64875 2.54044Z" />
  </svg>
</template>
